<template>
  <div>
    <!-- <h1>{{ this.$store.state.isAdmin }}</h1> -->
    <div class="menu" v-if="espera">
      <div class="container9">

        <ul class="hidden-sm-and-down">
          <li :class="{ activo: $route.name == 'inicio' || $route.name == 'operador' }"
            @click="getRuta($store.state.isAdmin ? 'inicio' : 'operador')">
            <span class="el-icon-s-home" style="padding: 1.2px 2px"></span>
            <span v-if="!$store.state.isAdmin"> COMISIONES</span>

          </li>

          <li v-if="$store.state.isAdmin" :class="{ activo: $route.name == 'liquidaciones' }"
            @click="getRuta('liquidaciones')">
            <span>COMISIONES FO</span>
          </li>

          <li v-if="$store.state.isAdmin" :class="{ activo: $route.name == 'farmaciasFo' }"
            @click="getRuta('farmaciasFo')">
            <span>FARMACIAS FO</span>
          </li>
          <li v-if="$store.state.isAdmin" :class="{ activo: $route.name == 'admin' }" @click="getRuta('admin')">
            <span>ADMIN</span>
          </li>
          <li v-if="$store.state.isAdmin" :class="{ activo: ['informes'].includes($route.name) }"
            @click="getRuta('informes')">
            <span>INFORMES</span>
          </li>
          <li v-if="$store.state.isAdmin" :class="{ activo: ['ayuda'].includes($route.name) }"
            @click="getRuta('ayuda')">
            <span>AYUDA</span>
          </li>
          <li v-if="$store.state.isAdmin" style="background:#03A9F4" @click="getTratamiento()">
            <span>TRATAMIENTOS</span>
          </li>
          <!-- <li style="background: #009688" @click="getRuta('farmacia')">
            <span>MI FARMACIA</span>
          </li> -->
          <!-- <li :class="{ activo: $route.name == 'faqs' }" @click="getRuta('faqs')">
            <span>AYUDA</span>
          </li> -->
          <li style="float: right; background: #E91E63; color: #FFF; font-weight: bold" @click="drawer = true">
            <span class="el-icon-collection-tag" style="padding: 1.4px"></span>
          </li>
          <li style="float: right; background: #00bcd4; color: #000; font-weight: bold"
            :class="{ activo: $route.name == 'home' }" @click="deleteSession()">
            <span>SALIR</span>
          </li>
          <li style="float: right; background: #9e9e9e; color: #000; font-weight: bold">
            <span>{{ operador.toUpperCase() }}
              <span v-if="$store.state.isAdmin">&nbsp;(ADMIN)</span>
              <span v-if="!$store.state.isAdmin">&nbsp;(NORMAL)</span>
            </span>
          </li>
        </ul>
      </div>
      <!-- <el-button type="primary" size="mini" class="historial" @click="drawer = true" icon="el-icon-collection-tag"></el-button> -->

    </div>
    <!-- <div
      style="
        background: #fce4ec;
        color: #000;
        padding: 10px;
        font-weight: 600;
      "
    >
      <div class="container">
        ENTREGAS SEGURAS: desde el 28 de mayo será obligatorio ingresar la palabra clave para entregar un pedido
      </div>
    </div> -->

    <el-dialog :show-close="false" :visible.sync="menuMovil" :fullscreen="true">
      <sc-menu-movil :farmacia="$store.state.farmacia" :operador="$store.state.operador" :permiso="$store.state.permiso"
        :domicilio="domicilio" />
    </el-dialog>
    <generarExcel />
    <el-drawer title="Historial" :visible.sync="drawer" :direction="'rtl'">
      <div slot="title">
        <h4 style="margin:0px">Historial <el-button type="primary" :loading="borrando" style="float:right" size="mini"
            @click="limpiarHistorial">Limpiar</el-button></h4>

      </div>
      <scHistorial></scHistorial>

    </el-drawer>

  </div>
</template>

<script>
//    import { HTTP, SC } from '@/axios.js'
import { EventBus } from "@/event-bus.js";
import estadoMixins from "@/mixins/estadosMixins.js";
import scMenuMovil from "@/components/smMenuMovil";
import scHistorial from "@/components/scHistorial";
import generarExcel from "@/components/modales/generarExcel";
export default {
  props: ["cliente"],
  mixins: [estadoMixins],
  components: {
    scMenuMovil,
    generarExcel,
    scHistorial
  },

  data() {
    return {
      borrando: false,
      drawer: false,
      medicinales: false,
      menuMovil: false,
      permiso: false,
      buscando: false,
      dni: this.$route.params.dni || "",
      pedido: this.$route.params.pedido || "",
      estado: 0,
      fijo: false,
      domicilio: false,
      mitienda: 0,
      roche: 0,
      espera: false,
      cliente2: this.$route.params.cliente ? this.$route.params.cliente : '',
      token: window.sessionStorage.getItem('token')
    };
  },
  created() {
    setTimeout(() => {
      this.espera = true
    }, 500);
  },

  methods: {
    getVedor() {
      let vedor = ['12952-cpelusso', '21408-juan.alderete']
      const operador = window.sessionStorage.getItem("operador") ? window.sessionStorage.getItem("operador") : 0
      return vedor.includes(operador)
    },
    getTratamiento() {
      window.open('https://tto.suizoargentina.com/public/tto/#/dispensas/liquidaciones?token=' + this.token)
    },
    limpiarHistorial() {
      this.borrando = true
      window.localStorage.removeItem('historial')
      setTimeout(() => {
        window.location.reload()
      }, 100);
    },
    generarExcel() {
      EventBus.$emit("verMenuExcel", this.$route.params, []);
    },
    buscar() {
      this.buscando = true;
      if (
        this.$route.name === "Domicilio" ||
        this.$route.name === "Pedidos" ||
        this.$route.name === "comisiones"
      ) {
        this.$route.params.dni = this.dni;
        this.$route.params.pedido = this.pedido;
        this.$route.params.cliente = this.farmacia.codigo;
        this.$route.params.estado = this.estado;
        this.$route.params.mitienda = this.mitienda;
        this.$route.params.roche = this.roche;
        setTimeout(() => {
          EventBus.$emit("buscar");
        }, 500);
      } else {
        let origen = this.$route.name;
        if (origen === "Pedidos" || origen === "inicio") {
          this.$router.push({
            name: "Pedidos",
            query: {
              token: window.sessionStorage.getItem("token"),
            },
            params: {
              dni: this.dni,
              pedido: this.pedido,
              cliente: this.farmacia.codigo,
              estado: this.estado,
              mitienda: this.mitienda,
              roche: this.roche,
            },
          });
        } else {
          this.$router.push({
            name: "Domicilio",
            query: {
              token: window.sessionStorage.getItem("token"),
            },
            params: {
              dni: this.dni,
              pedido: this.pedido,
              cliente: this.farmacia.codigo,
              estado: this.estado,
              mitienda: this.mitienda,
              roche: this.roche,
            },
          });
        }
      }
    },
    deleteSession() {
      window.sessionStorage.setItem("token", null);
      window.sessionStorage.setItem("cliente", null);
      window.sessionStorage.setItem("permisos", null);
      window.sessionStorage.clear();
      this.$router.push({
        name: "login",
        // query: {
        //   token: this.$route.query.token,
        // },
      });
    },
    buscarLiquidacion() {
      if (this.cliente2) {
        this.cargando = true;
        let ruta = "clienteDetalle";
        let params = { cliente: this.cliente2 };
        let query = { token: this.token };

        // Verificar si el parámetro del cliente o el query ya están en la ruta actual
        if (
          this.$route.name === ruta &&
          this.$route.params.cliente === this.cliente2 &&
          this.$route.query.token === this.token
        ) {
          // Si ya estás en la misma ruta con los mismos parámetros y query, no hacer nada
          console.log("Ya estás en la misma ruta con los mismos parámetros.");
          this.cargando = false;
        } else {
          // Si hay un cambio, entonces navega o reemplaza
          this.$router.push({ name: ruta, params: params, query: query });
        }
      }
    }

    ,
    getRuta(name) {
      if (name !== this.$route.name) {
        let nombre = name;
        switch (name) {
          case "comisiones":
            this.estado = 40;
            if (this.farmacia.admin_grupo === this.farmacia.codigo) {
              nombre = "comisionesGrupos";
            }
            break;
          case "liquidaciones":
            this.estado = 50;
            break;
          case "inicio":
            nombre = this.$store.state.isAdmin ? "inicio" : "operador";
            break;

          default:
            this.estado = 0;
            break;
        }
        setTimeout(() => {
          this.$router
            .push({
              name: nombre,
              query: {
                token: window.sessionStorage.getItem("token"),
              },
              params: {
                dni: "",
                pedido: "",
                cliente: this.farmacia ? this.farmacia.codigo : 8000,
                estado: this.estado ? this.estado : 0,
                mitienda: this.mitienda,
                roche: this.roche,
              },
            })
            .catch({});
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.historial {
  position: absolute;
}

.menu {
  background: #383838;
  height: 35px;
  margin-top: 0px;
}

.menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu ul li {
  color: white;
  display: inline-flex;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s;
  // margin-top: -4px;
  font-size: 14px;
}

.menu ul li>span {
  //   margin-top: -21px;
  display: flex;
  /* padding-bottom: 24px; */
  margin-left: 0px;
  margin-top: 2px;
}

.menu ul li:hover,
.menu ul li.activo {
  background: #bfbe51;
  padding: 8px 16px;
  border-color: #bfbe51;
  color: #000;
  font-weight: bold;
  // padding-left: 0;
}

.buscador {
  background: #f1f1f1;
  padding-top: 10px;
}

.buscador h4 {
  font-weight: 300;
  letter-spacing: 3px;
  margin-top: 32px;
  text-transform: uppercase;
  /* text-decoration: underline; */
  padding-bottom: 11px;
  border-bottom: 1px solid #dcdfe6;
  width: 90%;
}

@media screen and (min-width: 993px) and (max-width: 1130px) {
  .menu ul li {
    color: white;
    display: inline-flex;
    padding: 4px 6px;
    cursor: pointer;
    transition: all 0.2s;
    // margin-top: -4px;
    font-size: 13px;
  }

  .menu ul li>span {
    //   margin-top: -21px;
    display: flex;
    /* padding-bottom: 24px; */
    margin-left: 3px;
    margin-top: 6px;
  }

  .menu ul li:hover,
  .menu ul li.activo {
    background: rgba(81, 169, 241, 0.3215686274509804);
    padding: 4px 6px;
    // padding-left: 0;
  }
}

@media screen and (max-width: 992px) {
  .menuMovil {
    position: absolute;
    right: 10px;
    cursor: pointer;
    top: 6px;
    line-height: 0.1;
    font-size: 14px;
    text-align: center;
    color: #ff8278;
    font-weight: bold;
  }

  .menu {
    height: 5px;
    margin-top: -10px;
  }
}
</style>
